import { createContext, useContext } from "react";

import type { useProjectDetails } from "./hooks/use-project-details";

export type ProjectDetailsContextValue = ReturnType<typeof useProjectDetails>;

export const ProjectDetailsContext = createContext<ProjectDetailsContextValue | null>(null);

export function useProjectDetailsContext(): ProjectDetailsContextValue {
  const ctx = useContext(ProjectDetailsContext);
  if (!ctx) {
    throw new Error(
      "useProjectDetailsContext must be used within a <ProjectDetailsContext.Provider>. " +
        "Wrap your component tree with the provider in ProjectDetailsPage."
    );
  }
  return ctx;
}
